module.exports = __webpack_public_path__ + "static/img/back4.509c9ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/back4.png
// module id = EDhu
// module chunks = 0